import { render } from "./SideBannerLoader.vue?vue&type=template&id=1ffaf9dc"
import script from "./SideBannerLoader.vue?vue&type=script&lang=js"
export * from "./SideBannerLoader.vue?vue&type=script&lang=js"

import "./SideBannerLoader.vue?vue&type=style&index=0&id=1ffaf9dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__